// Default z-score view state for the PatientZScoresProvider. Exported so the
// "Reset settings" control in NeuroViewer can restore these to their originals.
export const DEFAULT_MONTAGE_TYPE = 'Bipolar';


export const DEFAULT_ZSCORE_VISUALIZATION_SETTINGS = {
    enabled: true,
    feature: '',
    colorByDirection: false,
    scaleByMagnitude: false,
    showClinicalOverlay: false,
    threshold: 2,
    // Default off: selecting a patient should show all their electrode locations
    // (z-score-colored where data exists). Thresholding hides every channel that
    // isn't an outlier, which made patients look empty on select — it's now opt-in.
    thresholdMode: false
};


// Define the normative panel tabs
export const NORMATIVE_TABS = {
    POPULATION: 'population',
    PATIENT: 'patient',
    POPULATION_DISTRIBUTION: 'population_distribution'
};
